import { PipeSeriesRepository } from "@imi-ernd-be/hyselect-engine";
import { CustomPipeSeries } from "@src/core/api/customPipeSeries";
import { PipeSeriesPreference } from "@src/core/api/pipeSeriesPreference";
import { logger } from "@src/shared/helpers/logger";
import { assert, first } from "radashi";
import { toArray } from "../vector";
import { buildPipe } from "./buildPipes";
import { setExistingPipeSeries } from "./setExistingPipeSeries";

export function setCustomPipeSeries(
  repository: PipeSeriesRepository,
  pipeSeriesPreference: PipeSeriesPreference,
  customPipeSeries: CustomPipeSeries[],
) {
  const enginePipeSeries = repository.createPipeSerie();
  assert(enginePipeSeries, "Failed to create custom pipe series");

  const customSerie = customPipeSeries.find(
    (series) => series.id === pipeSeriesPreference.pipeSeries,
  );
  const customPipePref = customSerie?.pipes.find(
    (p) => p.id === pipeSeriesPreference.pipes,
  );

  // If the custom series or pipe from the preferences is not found,
  // we use the default values.
  if (!customSerie) {
    logger.warn(
      "Custom pipe series or pipe not found in preferences, using default values",
    );
    setExistingPipeSeries(repository, undefined);
    enginePipeSeries.delete();
    return;
  }

  customSerie?.pipes.forEach((pipe) => {
    const pipeInSeries = enginePipeSeries.createPipe();
    assert(pipeInSeries, "Failed to create pipe in custom pipe series");

    pipeInSeries.name = pipe.name;
    pipeInSeries.setInternalDiameterVal(pipe.internalDiameter);
    pipeInSeries.setMaxPressureVal(pipe.maxPressure);
    pipeInSeries.setMaxTemperatureVal(pipe.maxTemperature);
    pipeInSeries.setRoughnessVal(pipe.roughness);
    pipeInSeries.setValveSize(pipe.valveSize);
    enginePipeSeries.addPipe(pipeInSeries);
    if (pipe.id === customPipePref?.id) {
      enginePipeSeries.setPipe(pipeInSeries);
    }
  });
  if (
    pipeSeriesPreference.pipes === "all" ||
    pipeSeriesPreference.pipes === null
  ) {
    const pipesList = toArray(enginePipeSeries.getPipesList());
    const allOption =
      pipesList.length === 1
        ? first(pipesList)
        : pipesList.find((pipe) => buildPipe(pipe).id === "all");
    if (!allOption) {
      logger.warn(
        "All option not found in custom pipe series, using default values",
        pipeSeriesPreference,
      );
      setExistingPipeSeries(repository, undefined);
      enginePipeSeries.delete();
      return;
    }
    enginePipeSeries.setPipe(allOption);
  }
  repository.addSerie(enginePipeSeries);
  repository.setSerie(enginePipeSeries);
}
